import QuestionValue from "./QuestionValue";

export default class QuestionValueAlgebra extends QuestionValue {
    constructor(coefficient, variable, unknownCharacter = "x") {
        super(coefficient * variable);
        this._coefficient = coefficient;
        this._variable = variable;
        this._unknownCharacter = unknownCharacter;
    }

    toString() {
        return (parseInt(this._coefficient) === 1) ? "" + this._unknownCharacter : this.coefficient + this._unknownCharacter;
    }

    get unknownCharacter() {
        return this._unknownCharacter;
    }

    get variable() {
        return this._variable;
    }

    get coefficient() {
        return this._coefficient;
    }
}